import { render } from "./MenuSmallTile.vue?vue&type=template&id=e819fed6&scoped=true"
import script from "./MenuSmallTile.vue?vue&type=script&lang=js"
export * from "./MenuSmallTile.vue?vue&type=script&lang=js"

import "./MenuSmallTile.vue?vue&type=style&index=0&id=e819fed6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e819fed6"]])

export default __exports__